module.exports = __webpack_public_path__ + "7d6cfb04ffb0bf00f18d6bc6439935d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-wizard.png
// module id = 998
// module chunks = 0